//@ts-nocheck
import React from "react";
import FirmPerformanceChurnsController, { Props } from "./FirmPerformanceChurnsController.web";
import { Typography, Grid, Box, withStyles, createStyles, MenuItem } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import MediumBlueField from "../../../../components/src/MediumBlueField.web";
import { commonStyles } from "../commonStyles";
import { largeChartOptions } from "../chartOptions";
import { Line } from "react-chartjs-2";
import { firmPerformanceStyles } from "./FirmPerformanceRevenue.web";

const StyledTableCell = withStyles((theme) => ({
  root: {
    width: (props) => (props.width ? props.width : "auto"),
    position: "relative",
    [theme.breakpoints.down("md")]: {
      padding: "8px",
    },
    "&:first-of-type": {
      borderTopLeftRadius: "0.75rem",
      borderBottomLeftRadius: "0.75rem",
    },
    "&:last-of-type": {
      borderTopRightRadius: "0.75rem",
      borderBottomRightRadius: "0.75rem",
    },
  },
  head: {
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
    fontWeight: "bold",
    fontFamily: "Nunito Sans",
    border: "none",
    backgroundColor: "#F3F3F3",
    padding: "1.2rem 0rem",
  },
  body: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
    border: "none",
    fontFamily: "Nunito Sans",
    backgroundColor: "#fff",
    padding: "1.2rem 0rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
}))(TableCell);

const churnsTimePeriodOptions = [
  { name: "Last 12 Months", value: 12 },
  { name: "Last 9 Months", value: 9 },
  { name: "Last 6 Months", value: 6 },
  { name: "Last 3 Months", value: 3 },
];

export class FirmPerformanceChurns extends FirmPerformanceChurnsController {
  constructor(props: Props) {
    super(props);
  }

  async componentDidMount() {
    const token = await StorageProvider.get("authToken");
    const accountId = await StorageProvider.get("accountId");

    this.setState(
      {
        token: token,
        accountId: accountId,
      },
      () => {
        this.getCancellationData(this.state.churnsTimePeriod);
      }
    );
  }

  selectChangeHandler = (e) => {
    this.setState({
      churnsTimePeriod: e.target.value,
    });
    this.getCancellationData(e.target.value);
  }

  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Grid
          container
          justifyContent="space-between"
          style={{
            position: "relative",
          }}
        >
          <Grid item xs={8} className={[classes.gridSpacing, classes.sectionHeadings]}>
            <Typography
              variant="h2"
              style={{
                color: theme.palette.text.blue2,
              }}
              id="page-heading-churns"
            >
              Churn
            </Typography>
          </Grid>

          <Grid container alignItems="center" justifyContent="flex-end" item xs={4}>
            <Typography color="primary" className={[classes.weight700, classes.size22, classes.textCard]}>
              0{" "}
              <Typography display="inline" color="textSecondary" className={[classes.size18]}>
                Proposals Cancelled
              </Typography>
            </Typography>
          </Grid>

          <Grid item xs={12} className={[classes.gridSpacing, classes.whiteCard]}>
            <Grid container justifyContent="space-between">
              <Grid item xs={12} className={[classes.sectionHeadings, classes.gridSpacing]} container justifyContent="space-between">
                <Typography
                  variant="h2"
                  style={{
                    color: theme.palette.text.blue2,
                  }}
                >
                  Cancellations
                </Typography>
                <MediumBlueField
                  onChange={this.selectChangeHandler}
                  select
                  value={this.state.churnsTimePeriod}
                  style={{
                    width: "12%",
                    marginRight: "2rem",
                  }}
                >
                  {churnsTimePeriodOptions.map((opt) => {
                    return (
                      <MenuItem key={opt?.name} value={opt?.value}>
                        {opt?.name}
                      </MenuItem>
                    );
                  })}
                </MediumBlueField>
              </Grid>
              <Grid
                item
                xs={9}
                className={[classes.gridSpacing]}
                style={{
                  paddingLeft: theme.spacing(6),
                }}
              >
                <Box
                  style={{
                    height: "21.875rem",
                  }}
                >
                  <Line data={this.state.cancellation_monthly_count} options={largeChartOptions} />
                </Box>
              </Grid>

              <Grid item xs={3}>
                <Grid container alignItems="flex-start" justifyContent="flex-end">
                  <Grid item xs={12} container alignItems="center" justifyContent="flex-end">
                    <Box className={classes.pieChartGreenBox} />
                    <Typography display="inline" color="textSecondary" className={classes.pieChartText}>
                      Recurring Payment (0%)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} container alignItems="center" justifyContent="flex-end">
                    <Box className={classes.pieChartBlueBox} />
                    <Typography display="inline" color="textSecondary" className={classes.pieChartText}>
                      One Time Payment (0%)
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className={[classes.gridSpacing]}>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <TableContainer>
                      <Table
                        aria-label="simple table"
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: "0px 8px",
                        }}
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell width="2%" />
                            <StyledTableCell width="35%">Package Name</StyledTableCell>
                            <StyledTableCell width="35%" align="center">
                              No. of Cancellations
                            </StyledTableCell>
                            <StyledTableCell width="28%" align="center">
                              Cancellation Rate
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={12} className={[classes.clientListCard]}>
                    <TableContainer>
                      <Table
                        aria-label="simple table"
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: "0px 8px",
                        }}
                      >
                        <TableBody>
                          {this.state.cancelationCount?.length ? (
                            this.state.cancelationCount.map((item, index) => {
                              return (
                                <TableRow className={classes.clientRow}>
                                  <StyledTableCell width="2%">
                                    <Box
                                      className={classes.clientListColorBar}
                                      style={{
                                        backgroundColor: theme.palette.primary.main,
                                      }}
                                    />
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "1.1rem",
                                    }}
                                    width="35%"
                                  >
                                    Accounting Success Package
                                  </StyledTableCell>
                                  <StyledTableCell
                                    align="center"
                                    style={{
                                      fontWeight: 600,
                                    }}
                                    width="35%"
                                  >
                                    {index + 10}
                                  </StyledTableCell>
                                  <StyledTableCell
                                    align="center"
                                    style={{
                                      fontWeight: 600,
                                    }}
                                    width="28%"
                                  >
                                    14.43%
                                  </StyledTableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <StyledTableCell align="center" colSpan={4}>
                                <Typography align="center">No data to display</Typography>
                              </StyledTableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}

const FirmPerformanceChurnsWithRouter = withRouter(FirmPerformanceChurns);
const FirmPerformanceChurnsAlertBox = withAlertBox(FirmPerformanceChurnsWithRouter);
const FirmPerformanceChurnsLoader = withLoader(FirmPerformanceChurnsAlertBox);
const FirmPerformanceChurnsToast = withToast(FirmPerformanceChurnsLoader);
const FirmPerformanceChurnsWithDialog = withDialog(FirmPerformanceChurnsToast);

export default withStyles(
  (theme) =>
    createStyles({
      ...commonStyles(theme),
      ...firmPerformanceStyles(theme),
    }),
  { withTheme: true }
)(withConfirmBox(FirmPerformanceChurnsWithDialog));
